module.exports = __webpack_public_path__ + "assets/img/bob_barker-29ad1046.jpg";